import { lazy } from "react";
import EmojiTransportationIcon from "@mui/icons-material/EmojiTransportation";
import Person4Icon from '@mui/icons-material/Person4';

const AssignDrivers = lazy(() => import("../assignDriver"));
const AssignedDriverView = lazy(() => import("../assignDriverView"));

const organizationDriverRoute = {
  icon: EmojiTransportationIcon,
  name: "Cab Vendor",
  link: "/cab-vendor",
  path: "cab-vendor",
  index: 5,
  superAdminView: false,
  element: "",
  children: [
    {
      path: "driver",
      element: <AssignDrivers />,
      name: "Drivers",
      permission: "Assign Drivers-Read",
      link: "/cab-vendor/driver",
      icon: Person4Icon,
      index: 2,
      superAdminView: false,
    },
    {
      path: "/cab-vendor/driver/:id",
      element: <AssignedDriverView />,
    },
  ],
};
export default organizationDriverRoute;
